import './Cart.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CartStepper } from './Stepper/Stepper';
import { OrderSummary } from './OrderSummary/OrderSummary';
import { useCartStore } from 'stores/SubscriptionsAndPricing/CartStore';
import { CartItem } from 'types/cart';
import { AvailableCertifications } from './Certifications/AvailableCertifications';

export const Cart = () => {
  const { t } = useTranslation();

  const addItemToCart = useCartStore((state) => state.addItemToCart);
  const setInitialized = useCartStore((state) => state.setInitialized);
  const initialized = useCartStore((state) => state.initialized);

  useEffect(() => {
    if (!initialized) {
      const cartFromLocalStorage = localStorage.getItem('cart');

      if (cartFromLocalStorage) {
        const parsedCart = JSON.parse(cartFromLocalStorage);
        parsedCart.items.forEach((item: CartItem) => addItemToCart(item));
      }
      setInitialized(true);
    }
  }, [initialized, addItemToCart, setInitialized]);

  const [activeStep, setActiveStep] = useState(0);

  return (
    <div className='cart-page'>
      <CartStepper activeStep={activeStep} handleActiveStep={setActiveStep} />
      <OrderSummary />
      <AvailableCertifications />
    </div>
  );
};
